import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'brightside-web-savings-account-main',
    templateUrl: './savings-account-main.component.html',
    styleUrls: ['./savings-account-main.component.scss'],
    standalone: false
})
export class SavingsAccountMainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
